module.exports = __webpack_public_path__ + "img/90deg.e74f02fd.svg";